<template>
  <v-app v-if="isLoading">
    <loading />
  </v-app>
  <div v-else>
    <v-col cols="12" class="pa-3">
      <v-row>
        <v-col cols="12" class="d-flex pb-0">
          <v-btn-toggle class="ml-auto">
            <v-btn
              :color="toggle_exclusive == 0 ? 'IMThemeGray text-white' : 'light'"
              @click="
                filterAds(1);
                toggle_exclusive = 0;
              "
              >الإعلانات</v-btn
            >
            <v-btn
              :color="toggle_exclusive == 1 ? 'IMThemeGray text-white' : 'light'"
              @click="
                filterAds(2);
                toggle_exclusive = 1;
              "
              >العروض</v-btn
            >
          </v-btn-toggle>
        </v-col>
        <v-col cols="12" lg="9">
          <v-card
            class="EK-card rounded-xl rounded-tr-0 EK-shadow IMTOrange text-center border-top border-right"
          >
            <v-data-table
              dense
              color="IMThemeGray"
              :headers="headers"
              :items="adList"
              hide-default-footer
              :search="searchText"
              :items-per-page="10"
              :page.sync="page"
              @page-count="pageCount = $event"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="searchText"
                  color="IMThemeGray"
                  label="بحث في الجدول"
                  style="width: 280px"
                  append-icon="mdi-magnify"
                  class="mx-4"
                ></v-text-field>
              </template>
              <template v-slot:item="{ item, index }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <tr
                      v-on="on"
                      v-bind="attrs"
                      @click="
                        edit(
                          item.type,
                          adList.findIndex((ad) => ad.id == item.id)
                        )
                      "
                      :class="{ active: adIndex == (page - 1) * 10 + index }"
                    >
                      <td>
                        <img
                          class="rounded-circle p-2"
                          :src="
                            !item.image[0]
                              ? placeholder
                              : !!item.image[0].path
                              ? domainHost + item.image[0].path.replace('~', '')
                              : item.image[0].base64
                          "
                          alt="media image"
                          width="120"
                          height="120"
                        />
                      </td>
                      <td>
                        {{ !item.shopName ? "بلا مشترك" : item.shopName }}
                      </td>
                      <td class="140px">
                        {{ item.type == 2 ? "عرض" : "إعلان" }}
                      </td>
                      <td>
                        {{ new Date(item.startDate).toISOString().substr(0, 10) }}
                      </td>
                      <td>
                        {{ new Date(item.endDate).toISOString().substr(0, 10) }}
                      </td>

                      <td>
                        <v-btn @click="onConfirmDelete(item)" text>
                          <img src="/media/svg/table/delete.svg" alt="delete" />
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                  <span>انقر لعرض التفاصيل</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <div class="w-100 pb-10 mt-10">
                <v-pagination
              color="IMThemeGray"
              v-model="page"
              :total-visible="10"
              :length="pageCount"
            ></v-pagination>
            
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" lg="3" class="action">
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
<style lang="scss" scoped>
.active {
  background: rgba(0, 0, 0, 0.125) !important;
}
</style>
<style lang="scss">
#type {
  width: 110px !important;
}
</style>
<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import loading from "@/components/loading";
import Swal from "sweetalert2";
 export default {
  data: () => ({
    toggle_exclusive: 0,
    page: 1,
    pageCount: 0,
    searchText: "",
    headers: [
      {
        text: "صورة الإعلان",
        value: "image",
        sortable: false,
      },
      {
        text: "اسم المشترك",
        value: "shopName",
        sortable: true,
      },
      {
        text: "تصنيف الإعلان",
        value: "type",
        sortable: true,
      },
      {
        text: "تاريخ بدء الإعلان",
        value: "startDate",
        sortable: false,
      },
      {
        text: "تاريخ انتهاء الإعلان",
        value: "endDate",
        sortable: false,
      },
      {
        text: "حذف",
        value: "delete",
        sortable: false,
      },
    ],
  }),
  props: {
    adIndex: String,
  },
  computed: {
    ...mapGetters([
      "adList",
      "isLoading",
      "adsListNotFilterd",
      "domainHost",
      "placeholder",
    ]),
  },
  created() {
    this.setBreadcrumbs([
      {
        text: "الإعلانات والعروض",
        disabled: false,
        href: "/ad",
      },
    ]);
    this.fetchAd();
    this.fetchCitiesList();
    this.fetchShopsList();
  },
  components: {
    loading,
  
  },
  methods: {
    ...mapActions([
      "setBreadcrumbs",
      "fetchAd",
      "currentAd",
      "fetchCitiesList",
      "fetchShopsList",
        "filterAds",
        "changePage",

    ]),
      nextPage(page) {
          this.page = page;
          this.changePage(page);
      },
    onConfirmDelete(item) {
      Swal.fire({
        title: "هل انت متأكد من الحذف ؟",
        text: "مازال بإمكانك التراجع",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "تراجع",
        confirmButtonText: "أجل متأكد",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("deleteAd", item);
        }
      });
    },
    edit(type, index) {
      if (index != this.adIndex) {
        this.$router.push(`/ad/${type}/${index}`);
      }
    },
  },
};
</script>
